(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pills = document.querySelectorAll('#productos .pill');
  pills.forEach(function (btn) {
    btn.addEventListener('click', function () {
      pills.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var group = this.getAttribute('data-filter');
      document.querySelectorAll('#productos .filter-group').forEach(function (g) {
        g.classList.toggle('active', g.getAttribute('data-group') === group);
      });
    });
  });
}());

  } catch(e) { console.error(e); }
})();
})();
